var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('widget-news-list',{ref:"WidgetNews",on:{"refresh":_vm.RefreshClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }